export default __webpack_public_path__ + "static/media/share-square-icon.62293ad0.svg";